<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Settings" />
    </template>

    <div class="css-v2 reports-list" v-if="settingsLoaded">
      <gc-split-view :showLeftContainer="true" :showRightContainer="true">
        <template #leftContent>
          <DxTreeView
            :data-source="userAccessibleSettings"
            :select-by-click="true"
            selection-mode="single"
            @selection-changed="itemClick"
            :ref="'report-list-menu'"
            @content-ready="contentReady"
          />
        </template>

        <template #rightContent>
          <dx-data-grid
            :data-source="dataSourceConfig"
            :columns="columns"
            @selection-changed="onSelectionChanged"
            :height="gridHeight - 20"
            :column-chooser="{ enabled: false }"
          >
            <DxPaging :page-size="50" :enabled="false" />
            <DxPager :visible="false" />

            <DxScrolling
              :mode="'virtual'"
              :row-rendering-mode="'virtual'"
              :preloadEnabled="true"
            />
          </dx-data-grid>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { FeatureStorage } from "../../_services/storage";

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: {},

  data() {
    return {
      dataSourceConfig: [],
      settingsLoaded: false,
      defaultCompany: "",
      userAccessibleSettings: [],
    };
  },
  async created() {
    this.$store.dispatch("globalFields/getGlobalFields");
    await this.$store.dispatch("screenFactors/getFactors", [18]);

    this.defaultCompany = this.getFactorByCode(18).Factorc;
    var featureItems = FeatureStorage.getItems().filter(
      (x) =>
        x.Type == "Work Centre" ||
        x.Type == "Module" ||
        x.Type == "Screen" ||
        x.Type == "Settings Screen"
    );

    this.menuItems.forEach((item) => {
      if (
        featureItems.some(
          (x) => x.ApplicationFeatureCode == item.applicationFeatureCode
        )
      ) {
        var validSettings = [];
        item.Settings.forEach((screen) => {
          if (
            featureItems.some(
              (x) => x.ApplicationFeatureCode == screen.applicationFeatureCode
            )
          ) {
            validSettings.push(screen);
          }
        });

        item.Settings = validSettings;
        if (item.Settings.length > 0) this.userAccessibleSettings.push(item);
      }
    });

    this.settingsLoaded = true;
  },
  methods: {
    contentReady(e) {
      if (this.baseView.id) {
        this.menuItems.forEach((element) => {
          if (element.text.toLowerCase() == this.baseView.id.toLowerCase()) {
            this.dataSourceConfig = element.Settings;
            e.component.selectItem(element.id);
            if (element.text) document.title = "Settings : " + element.text;
          }
        });
      } else {
        if (this.userAccessibleSettings.length > 0)
          e.component.selectItem(this.userAccessibleSettings[0].id);
      }
    },
    itemClick(e) {
      if (e) {
        this.$logger.debug("e itemClick", e);
        const selectedSettings = e.component
          .getSelectedNodes()
          .map((node) => node.itemData);
        if (selectedSettings.length > 0) {
          if (
            this.baseView.id.toLowerCase() !=
            selectedSettings[0].text.toLowerCase()
          ) {
            this.$router
              .push({
                path: "/settings" + selectedSettings[0].path,
              })
              .then(() => {
                document.title = "Settings : " + selectedSettings[0].text;
              });
          }
          this.dataSourceConfig = selectedSettings[0].Settings;
        }

        // this.$logger.debug("selectedEmployees ", selectedSettings);
      }
    },
    onSelectionChanged(e) {
      this.$logger.debug("e ", e);
      this.$logger.debug("baseview ", this.baseView);
      this.$router.push({
        path: e.selectedRowsData[0].path,
      });
    },
  },
  computed: {
    menuItems() {
      return [
        // Text & Path should be the same string - paths comes with '/' to the front.
        // Accounting
        {
          id: 1,
          text: "Accounting",
          path: "/accounting",
          type: "Module",
          applicationFeatureCode: "SettingsModule",
          Settings: [
            {
              id: 1,
              name: "Currencies",
              path: "/currency",
              type: "Screen",
              applicationFeatureCode: "CompanyCurrency",
            },
            {
              id: 2,
              name: "Tax Categories",
              path: "/tax-category",
              type: "Screen",
              applicationFeatureCode: "Tax",
            },
          ],
        },

        // Company
        {
          id: 7,
          text: "Company",
          path: "/company",
          type: "Module",
          applicationFeatureCode: "AccountsPayableModule",
          Settings: [
            {
              id: 1,
              name: "Company Details",
              path: `/company/review/${this.defaultCompany}`,
              type: "Screen",
              applicationFeatureCode: "Company",
            },
            {
              id: 2,
              name: "Branches",
              path: "/branch",
              type: "Screen",
              applicationFeatureCode: "Branch",
            },
            {
              id: 3,
              name: "Divisions",
              path: "/division",
              type: "Screen",
              applicationFeatureCode: "Division",
            },
          ],
        },
        // Customers
        {
          id: 2,
          text: "Customers",
          path: "/customers",
          type: "Work Centre",
          applicationFeatureCode: "AccountsWorkCentre",
          Settings: [
            {
              id: 1,
              name: "Types",
              path: "/customer-type",
              type: "Screen",
              applicationFeatureCode: "CustomerType",
            },
            {
              id: 2,
              name: "Drop Codes",
              path: "/drop-code",
              type: "Screen",
              applicationFeatureCode: "DropCode",
            },
            {
              id: 2,
              name: "Groups",
              path: "/customer-group",
              type: "Screen",
              applicationFeatureCode: "CustomerGroup",
            },
            {
              id: 3,
              name: "Market",
              path: "/customer-market",
              type: "Screen",
              applicationFeatureCode: "CustomerMarket",
            },
            {
              id: 4,
              name: "Reporting Group 1",
              path: "/customer-reporting-group-1",
              type: "Screen",
              applicationFeatureCode: "CustomerReportingGroup1",
            },
            {
              id: 5,
              name: "Reporting Group 2",
              path: "/customer-reporting-group-2",
              type: "Screen",
              applicationFeatureCode: "CustomerReportingGroup2",
            },
            {
              id: 6,
              name: "Reporting Group 3",
              path: "/customer-reporting-group-3",
              type: "Screen",
              applicationFeatureCode: "CustomerReportingGroup3",
            },
            {
              id: 7,
              name: "Region",
              path: "/customer-region",
              type: "Screen",
              applicationFeatureCode: "CustomerRegion",
            },
            {
              id: 8,
              name: "Sub Region",
              path: "/customer-sub-region",
              type: "Screen",
              applicationFeatureCode: "CustomerSubRegion",
            },
            {
              id: 9,
              name: "Sales Representative",
              path: "/customer-sales-representative",
              type: "Screen",
              applicationFeatureCode: "CustomerSalesRepresentative",
            },
            {
              id: 10,
              name: "Contract Line Description",
              path: "/customer-contract-line-description",
              type: "Screen",
              applicationFeatureCode: "CustomerContractLineDescription",
            },
          ],
        },
        // Products
        {
          id: 3,
          text: "Products",
          path: "/products",
          type: "Work Centre",
          applicationFeatureCode: "InventoryWorkCentre",
          Settings: [
            {
              id: 1,
              name: "Category 1",
              path: "/product-category-1",
              type: "Settings Screen",
              applicationFeatureCode: "ProductCategory1",
            },
            {
              id: 2,
              name: "Category 2",
              path: "/product-category-2",
              type: "Settings Screen",
              applicationFeatureCode: "ProductCategory2",
            },
            {
              id: 3,
              name: "Category 3",
              path: "/product-category-3",
              type: "Settings Screen",
              applicationFeatureCode: "ProductCategory3",
            },
            {
              id: 4,
              name: "Category 4",
              path: "/product-category-4",
              type: "Settings Screen",
              applicationFeatureCode: "ProductCategory4",
            },
            {
              id: 5,
              name: "Types",
              path: "/product-type",
              type: "Settings Screen",
              applicationFeatureCode: "ProductType",
            },
            {
              id: 6,
              name: "Sizes",
              path: "/product-size",
              type: "Settings Screen",
              applicationFeatureCode: "ProductSize",
            },
            {
              id: 7,
              name: "Bin Locations",
              path: "/bin-location",
              type: "Settings Screen",
              applicationFeatureCode: "BinLocation",
            },
            {
              id: 8,
              name: "Units Of Measure",
              path: "/unit-of-measure",
              type: "Settings Screen",
              applicationFeatureCode: "UnitOfMeasure",
            },
            {
              id: 9,
              name: "Filter Groups",
              path: "/product-filter-group",
              type: "Settings Screen",
              applicationFeatureCode: "ProductFilterGroup",
            },
            {
              id: 10,
              name: "Category Labels",
              path: "/category-labels",
              type: "Settings Screen",
              applicationFeatureCode: "EditCategoryLabels",
            },
            {
              id: 7,
              name: "Bin Location Type",
              path: "/bin-location-type",
              type: "Settings Screen",
              applicationFeatureCode: "BinLocation",
            },
          ].concat(this.getProductAttributeSettings),
        },
        // Sales
        {
          id: 4,
          text: "Sales",
          path: "/sales",
          type: "Module",
          applicationFeatureCode: "SalesModule",
          Settings: [
            {
              id: 1,
              name: "Sales Order Types",
              path: "/sales-order-types",
              type: "Screen",
              applicationFeatureCode: "SalesOrderType",
            },
            {
              id: 2,
              name: "Call Types",
              path: "/call-type",
              type: "Screen",
              applicationFeatureCode: "CallType",
            },
            {
              id: 3,
              name: "Survey Templates",
              path: "/survey-template",
              type: "Screen",
              applicationFeatureCode: "SurveyTemplate",
            },
          ],
        },
        // Suppliers
        {
          id: 5,
          text: "Suppliers",
          path: "/suppliers",
          type: "Module",
          applicationFeatureCode: "AccountsPayableModule",
          Settings: [
            {
              id: 1,
              name: "Types",
              path: "/supplier-type",
              type: "Screen",
              applicationFeatureCode: "SupplierType",
            },
          ],
        },
        // User
        {
          id: 6,
          text: "User",
          path: "/user",
          type: "Module",
          applicationFeatureCode: "SettingsModule",
          Settings: [
            {
              id: 1,
              name: "Features",
              path: "/feature",
              type: "Screen",
              applicationFeatureCode: "FeatureManagement",
            },
            {
              id: 2,
              name: "User Types",
              path: "/user-type",
              type: "Screen",
              applicationFeatureCode: "UserTypeManagement",
            },
            {
              id: 3,
              name: "Users",
              path: "/user",
              type: "Screen",
              applicationFeatureCode: "UserManagement",
            },
          ],
        },
        // Finance
        {
          id: 8,
          text: "Finance",
          path: "/finance",
          type: "Module",
          applicationFeatureCode: "FinanceModule",
          Settings: [
            {
              id: 1,
              name: "GL Reporting Group 1",
              path: "/gl-reporting-group-1",
              type: "Screen",
              applicationFeatureCode: "GLReportingGroup1",
            },
            {
              id: 2,
              name: "GL Reporting Group 2",
              path: "/gl-reporting-group-2",
              type: "Screen",
              applicationFeatureCode: "GLReportingGroup2",
            },
            {
              id: 3,
              name: "GL Reporting Group 3",
              path: "/gl-reporting-group-3",
              type: "Screen",
              applicationFeatureCode: "GLReportingGroup3",
            },
            {
              id: 4,
              name: "GL Auto Post Accounts",
              path: "/gl-auto-post-accounts",
              type: "Screen",
              applicationFeatureCode: "GLAutoPostAccounts",
            },
          ],
        },
        // // Inventory
        {
          id: 9,
          text: "Inventory",
          path: "/inventory",
          type: "Module",
          applicationFeatureCode: "InventoryModule",
          Settings: [
            {
              id: 1,
              name: "Season",
              path: "/season",
              type: "Settings Screen",
              applicationFeatureCode: "AlmondcoIntakeSeason",
            },
          ],
        },
      ];
    },
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Settings",
          dataField: "name",
          gcType: "String",
          gcSubType: "PrimaryRecord",
        },
      ]);
    },
    getProductAttributeSettings() {
      var Settings = [];
      for (var i = 1; i <= 20; i++) {
        Settings.push({
          id: i + 7,
          name: "Product Attribute " + ("0" + i).slice(-2),
          path: "/product-attribute-" + ("0" + i).slice(-2),
          type: "Screen",
          applicationFeatureCode: "ProductAttribute" + ("0" + i).slice(-2),
        });
      }

      return Settings;
    },
  },
};
</script>

<style lang="scss" >
.css-v2.reports-list {
  .dx-treeview-node-container .dx-treeview-node {
    margin: 0 !important;
  }
  .split-container-child.left-container {
    padding-left: 5px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 3px;
  }

  .dx-widget.dx-collection.dx-treeview {
    background-color: white;
    border-radius: 3px;
  }

  .split-container-child.right-container {
    padding: 10px 10px 10px 0;
    border-left: unset !important;
  }
}
</style>